export const ANALYTICS_SURFACE_PLACEMENTS = Object.freeze({
  DATASET: 'dataset',
  COMPANY: 'company',
});

export const createAnalyticsSurfaceContext = ({
  placement = ANALYTICS_SURFACE_PLACEMENTS.DATASET,
  routeOwner = null,
  embedded = placement === ANALYTICS_SURFACE_PLACEMENTS.COMPANY,
  filterContainer = undefined,
  filterLeftContent = null,
  viewDescriptor = null,
  companyContext = null,
} = {}) => ({
  placement,
  routeOwner: routeOwner || placement,
  embedded,
  filterContainer,
  filterLeftContent,
  viewDescriptor,
  companyContext,
});

export const isEmbeddedAnalyticsSurface = (surfaceContext) => (
  Boolean(surfaceContext?.embedded)
);
